import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ShareIcon from "@mui/icons-material/Share";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";

type Props = {
  row: any;
  onView: (form: any) => void;
  onShare: (form: any) => void;
  onViewSubmissions: (form: any) => void;
};

const HubspotActionsDropdown: React.FC<Props> = ({ row, onView, onShare, onViewSubmissions }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    handleClose();
    onView(row);
  };

  const handleShareClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    handleClose();
    onShare(row);
  };

  const handleViewSubmissionsClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    handleClose();
    onViewSubmissions(row);
  };

  return (
    <>
      <IconButton onClick={handleOpen} size="small" sx={{ p: 0.3 }}>
        <MoreVertIcon sx={{ fontSize: "20px" }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            borderRadius: 2,
            minWidth: 140,
          },
        }}
      >
        <MenuItem onClick={handleViewClick}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <VisibilityIcon fontSize="small" sx={{ color: "#666" }} />
          </ListItemIcon>
          <ListItemText primary="View" primaryTypographyProps={{ fontSize: "14px", color: "#333" }} />
        </MenuItem>
        {/* <MenuItem onClick={handleShareClick}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <ShareIcon fontSize="small" sx={{ color: "#666" }} />
          </ListItemIcon>
          <ListItemText primary="Share" primaryTypographyProps={{ fontSize: "14px", color: "#333" }} />
        </MenuItem> */}
        <MenuItem onClick={handleViewSubmissionsClick}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <FormatListNumberedIcon fontSize="small" sx={{ color: "#666" }} />
          </ListItemIcon>
          <ListItemText primary="View Submissions" primaryTypographyProps={{ fontSize: "14px", color: "#333" }} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default HubspotActionsDropdown;
